import React from 'react';

const Error = () => {
    return (
        <div className='text-center bg-teal-600 p-10'>
            <h1 className='text-white text-4xl my-10'>404</h1>
            <h1 className='text-white text-4xl'>Uppss....... Nothing Here</h1>
        </div>
    );
};

export default Error;